const d3 = require('d3')

const moment = require('moment');

const momentSort = ({date:date1},{date:date2})=>moment(date1).diff(moment(date2),'seconds')

function wrap(text, width) {
  text.each(function () {
    var text = d3.select(this),
      words = text.text().split(/\s+/),
      word,
      line = [],
      lineNumber = 0,
      lineHeight = 1.2, // ems
      y = text.attr('y'),
      dy = parseFloat(text.attr('dy')),
      tspan = text
        .text(null)
        .append('tspan')
        .attr('x', 0)
        .attr('y', y)
        .attr('dy', dy + 'em');
    while ((word = words.pop())) {
      line.push(word);
      line.pop();
      tspan.text(line.join(' '));
      line = [word];
      tspan = text
        .append('tspan')
        .attr('x', 0)
        .attr('y', y)
        .attr('dy', ++lineNumber * lineHeight + dy + 'em')
        .text(word);
    }
  });
}

//for excluding from this wrap add "exclude-wrap" class name to the text
function wrapByWidth(text, breakLineWidth) {  
  text.each(function () {
    var text = d3.select(this)
    if (text.classed('exclude-wrap')) return
    var words = text.text().split(/\s+/).reverse(),
        word,
        line = [],
        lineNumber = 0,
        lineHeight = 1.1, // ems
        x = text.attr("x"),
        y = text.attr("y"),
        dy = parseFloat(text.attr("dy")),
        tspan = text.text(null).append("tspan")
                    .attr("x", x)
                    .attr("y", y)
                    .attr("dy", dy + "em");
    setTimeout(() => {
      while (word = words.pop()) {
        line.push(word);
        tspan.text(line.join(" "));
        // Check if adding the next word exceeds the breakLineWidth
        if (tspan.node().getComputedTextLength() > breakLineWidth) {
          line.pop(); // Remove the last word
          tspan.text(line.join(" ")); // Update tspan with the current line
          line = [word]; // Start a new line with the current word
          tspan = text.append("tspan")
                      .attr("x", x)
                      .attr("y", y)
                      .attr("dy", ++lineNumber * lineHeight + dy + "em") // Move to the next line
                      .text(word);
        }
      }
    },0) 
  });
}

function isInLimits(val, min, max){
  return val && val >= min && val < max
}

module.exports= {
  momentSort,
  wrap,
  wrapByWidth,
  isInLimits
}
